import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class TrackUntrackSchLService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following update-change-list service pattern exactly
  trackUntrackSchL(
    baseUrl: string,
    returnClobSettingsObj: any,
    save_json: any,
    globalService: any,
    filterParams: any,
    logged_in_user: string,
    rowData: any
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action codes like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=p5e2vl`;

    // 🚀 CRITICAL: Build JSON objects exactly like AngularJS service
    const jsonObj = JSON.stringify(returnClobSettingsObj || []);
    const jsonSetting = JSON.stringify(save_json || {});
    
    // 🚀 CRITICAL: Build params with exact parameter names as specified
    // sso_id:String:null,tax_year:String:null,scenario:String:null,jcd_key:String:null,jsonSetting:String:null,jsonObj:String:null
    let params: any = {};
    
    // Extract values with proper fallbacks - convert to String or null
    params.sso_id = logged_in_user || globalService?.sso_id || filterParams?.sso_id || null;
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || null;
    params.scenario = filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || null;
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || null;
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.process_name = filterParams.process_name || "Track/Untrack Sch L";
    params.jsonSetting = jsonSetting || null;
    params.jsonObj = jsonObj || null;
    
    // Convert null values to string "null" as per requirement (String:null)
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === undefined) {
        params[key] = 'null';
      } else {
        params[key] = String(params[key]);
      }
    });

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // Fetch max count entities method
  fetchMaxCountEntities(
    baseUrl: string,
    params: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

